module.exports = __webpack_public_path__ + "static/media/quiks_privacy_en.9d8280fb.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/quiks_privacy_en.md
// module id = 65
// module chunks = 0